import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './COMEQ_Investor_Report.css';

const COMEQ_Investor_Report = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"COMEQ_INVESTOR_REPORT",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	COMEQ_INVESTOR_REPORT:-1
  });


  const [COMEQ_INVESTOR_REPORT, setCOMEQ_INVESTOR_REPORT] = React.useState(null);
  const [COMEQ_INVESTOR_REPORT_D, setCOMEQ_INVESTOR_REPORT_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Common Equity Token Investor Report');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCOMEQ_INVESTOR_REPORT(clientInfo,"OpenNew");

		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCOMEQ_INVESTOR_REPORT(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCOMEQ_INVESTOR_REPORT(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCOMEQ_INVESTOR_REPORT(clientInfo,"OpenNew");
		}
		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
		if(Temp_Data2.status!="New"){
			handleDeleteCOMEQ_INVESTOR_REPORT(Temp_Data2);
			navigate('/COMEQ_Investor_Report#New',{replace:true});
		} 
		else 
			navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Investor_Report',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!COMEQ_INVESTOR_REPORT) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_${i}_SECTION`;
	  const headerId = `#COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [COMEQ_INVESTOR_REPORT]) ;


  
  
  var Ids = [];
  for(var Ele in COMEQ_INVESTOR_REPORT){
	  for(var Sec in COMEQ_INVESTOR_REPORT[Ele]){
		if(Sec == "id")
			Ids.push(COMEQ_INVESTOR_REPORT[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(COMEQ_INVESTOR_REPORT[Ele]["status"]);
		else if(Array.isArray(COMEQ_INVESTOR_REPORT[Ele][Sec]))
			  for(var Row in COMEQ_INVESTOR_REPORT[Ele][Sec])  // Convert to COMEQ_INVESTOR_REPORT[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in COMEQ_INVESTOR_REPORT[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["COMEQ_INVESTOR_REPORT"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCOMEQ_INVESTOR_REPORT(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT`).then((response1) => {
		if(!COMEQ_INVESTOR_REPORT) 
			setCOMEQ_INVESTOR_REPORT(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT_D`).then((response2) => {
			setCOMEQ_INVESTOR_REPORT_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCOMEQ_INVESTOR_REPORT_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCOMEQ_INVESTOR_REPORT = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCOMEQ_INVESTOR_REPORT(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCOMEQ_INVESTOR_REPORT = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCOMEQ_INVESTOR_REPORT = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCOMEQ_INVESTOR_REPORT = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCOMEQ_INVESTOR_REPORT = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_INVESTOR_REPORT', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["1"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("1","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["1"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("1","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["1"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("1","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["1"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("1","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["4"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("4","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["4"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("4","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["4"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("4","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["5"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("5","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["5"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("5","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4"]=value;
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["6"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("6","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["9"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0"]=value;
	Form_Data_onChange("9","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["9"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("9","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["9"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("9","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["9"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("9","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["9"]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4"]=value;
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
	Form_Data_onChange("9","COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4",value,Temp_Data);
 	//handleLastDataCOMEQ_INVESTOR_REPORT(Temp_Data);
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
 }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));  
  Temp_Data['2'][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0"] = value;
  setCOMEQ_INVESTOR_REPORT(Temp_Data);
};


const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["2"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["2"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["2"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  


const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));  
  Temp_Data['3'][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0"] = value;
  setCOMEQ_INVESTOR_REPORT(Temp_Data);
};


const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["3"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["3"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["3"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  

const COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
	Temp_Data["3"][index]["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4"]=value;
    setCOMEQ_INVESTOR_REPORT(Temp_Data);
	//handleAddCOMEQ_INVESTOR_REPORT(Temp_Data,App_Data['COMEQ_INVESTOR_REPORT']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!COMEQ_INVESTOR_REPORT) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3']='';
	    break;
	  case('3'):
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3']='';
	    newRow['COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4']='';
	    break;

  }


  const updatedCOMEQ_INVESTOR_REPORT =JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
  updatedCOMEQ_INVESTOR_REPORT[Sec] = [...updatedCOMEQ_INVESTOR_REPORT[Sec], newRow];
  setCOMEQ_INVESTOR_REPORT(updatedCOMEQ_INVESTOR_REPORT);
};

const handleDeleteRow = (sec,index) => {
  const updatedCOMEQ_INVESTOR_REPORT = JSON.parse(JSON.stringify(COMEQ_INVESTOR_REPORT));
  updatedCOMEQ_INVESTOR_REPORT[sec].splice(index, 1);
  setCOMEQ_INVESTOR_REPORT(updatedCOMEQ_INVESTOR_REPORT);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Common Equity Token Investor Report`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Common Equity Token Investor Report ID`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`COMEQ Investor Report ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0" type="text" className="form-control" placeholder="COMEQ Investor Report ID" value={COMEQ_INVESTOR_REPORT["1"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter COMEQ Investor Report ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1" type="text" className="form-control" placeholder="Investor ID" value={COMEQ_INVESTOR_REPORT["1"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2" type="text" className="form-control" placeholder="Offering ID" value={COMEQ_INVESTOR_REPORT["1"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Report Period`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3" type="text" className="form-control" placeholder="Report Period" value={COMEQ_INVESTOR_REPORT["1"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Report Period`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_HEADER">{t(`Report Line Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Report Line Type`)}</th>
                        <th>{t(`Token Balance`)}</th>
                        <th>{t(`Ownership Percentage Total`)}</th>
                        <th>{t(`Income Allocation Percentage Total`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {COMEQ_INVESTOR_REPORT['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0"  onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0_Change(ev, i)}  className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_0`]} name="Report Line Type">
						  <option value="Token Balance">Token Balance</option>
						  <option value="Ownership Percentage">Ownership Percentage</option>
						  <option value="Income Allocation">Income Allocation</option>
						  <option value="Distribution">Distribution</option>
						  <option value="Risk Update">Risk Update</option>
						  <option value="Milestone Update">Milestone Update</option>
						  <option value="Narrative Update">Narrative Update</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_1`]} placeholder="Token Balance"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_2`]} placeholder="Ownership Percentage Total"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_2_3`]} placeholder="Income Allocation Percentage Total"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_HEADER">{t(`Report Line Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Report Line Type`)}</th>
                        <th>{t(`Gross Distribution USD`)}</th>
                        <th>{t(`Fees USD`)}</th>
                        <th>{t(`Net Distribution USD`)}</th>
                        <th>{t(`Estimated Current Value USD`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {COMEQ_INVESTOR_REPORT['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0"  onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0_Change(ev, i)}  className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_0`]} name="Report Line Type">
						  <option value="Token Balance">Token Balance</option>
						  <option value="Ownership Percentage">Ownership Percentage</option>
						  <option value="Income Allocation">Income Allocation</option>
						  <option value="Distribution">Distribution</option>
						  <option value="Risk Update">Risk Update</option>
						  <option value="Milestone Update">Milestone Update</option>
						  <option value="Narrative Update">Narrative Update</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_1`]} placeholder="Gross Distribution USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_2`]} placeholder="Fees USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_3`]} placeholder="Net Distribution USD"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4`]} data-search={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4" type="text" onChange={(ev) => COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4_Change(ev, i)} className="form-control" value={e[`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_3_4`]} placeholder="Estimated Current Value USD"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Current Risk Percentage`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Risk Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0" type="text" className="form-control" placeholder="Current Risk Percentage" value={COMEQ_INVESTOR_REPORT["4"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Current Risk Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Risk Color ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1" type="text" className="form-control" placeholder="Risk Color ID" value={COMEQ_INVESTOR_REPORT["4"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Risk Color ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Key Update`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2" type="text" className="form-control" placeholder="Key Update" value={COMEQ_INVESTOR_REPORT["4"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_4_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Key Update`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Report Link`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0" type="text" className="form-control" placeholder="Report Link" value={COMEQ_INVESTOR_REPORT["5"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Report Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Delivered At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1" type="text" className="form-control" placeholder="Delivered At" value={COMEQ_INVESTOR_REPORT["5"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Delivered At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0" type="text" className="form-control" placeholder="Submitted By" value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1" type="text" className="form-control" placeholder="Submitted At" value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2" type="text" className="form-control" placeholder="Reviewed By" value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3" type="text" className="form-control" placeholder="Reviewed At" value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4"  value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4`]} onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5" type="text" className="form-control" placeholder="Approval Notes" value={COMEQ_INVESTOR_REPORT["6"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_6_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0"  value={COMEQ_INVESTOR_REPORT["9"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0`]} onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1" type="text" className="form-control" placeholder="Created By" value={COMEQ_INVESTOR_REPORT["9"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2" type="text" className="form-control" placeholder="Created At" value={COMEQ_INVESTOR_REPORT["9"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3" type="text" className="form-control" placeholder="Updated By" value={COMEQ_INVESTOR_REPORT["9"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4" type="text" className="form-control" placeholder="Updated At" value={COMEQ_INVESTOR_REPORT["9"][`COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4`]} 
						onChange={COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_COMEQ_INVESTOR_REPORT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default COMEQ_Investor_Report;  